export default __webpack_public_path__ + "7d6fc82e60e8c63df56357182f78fcd2.png";